import tools from './tools'
import axios from 'axios'
import config from './config'
import router from '../router'
import {Message} from 'iview'
import errorCode from './errorCode'
import common from './common'



let isExp = () => { 
   var arrStr = document.cookie.split("; ");
   let flag = 0
   for(var i = 0;i < arrStr.length;i ++){ 
     var temp = arrStr[i].split("="); 
      if(temp[0] == 'Authorization') {
        flag = 1
      } 
    }

    if(flag==1){
      return true
    }else{
      return false
    }


}



/*请求接口获取token
 * @param url string token接口
 * @param data object 传入的数据对象
 * @param type int 类型 1获取token 2刷新token
 */

const navLang = navigator.language

let localLang1 = (navLang === 'zh-CN' || navLang === 'en-US' || navLang === 'en' || navLang === 'zh') ? navLang : false

let langObj = {'en':'en-US','en-US':'en-US','zh':'zh-CN','zh-CN':'zh-CN'}
let localLang = langObj[localLang1]
let local = tools.getLocal1('local') || localLang || 'en-US'

// console.log('local',local)
// console.log('navLang',navLang)
// console.log('localLang1',localLang1)
// let local = 'en-US'
// let store = tools.getSession("store") 

// if(store && store.langSet){
//   local = tools.getLocal1('local') || localLang || 'en-US'
// }else{
//   local= localLang || tools.getLocal1('local') || 'en-US'
// }



let getNewToken = (url, data, type, fn,fns)=> {
    fn = fn || function(){}
    fns = fns|| function(){}
    axios.post(url, data).then(function(response) {
      // console.log('responseLogin',response)
      // if(Object.prototype.toString.call(response)=='[object Object]'){
      //    response = response.data
      // }


    if(response.data.code === 1){
      tools.setSession('uInfo',response.data.data);
      tools.setSession('token',response.data.data.jwt);
      tools.setSession('refreshToken',response.data.data.jwt);
     
      common.encryptDataUinfo(response.data.data)
      // tools.setLocal('uInfo',common.encryptData(response.data.data))
      tools.setLocal('token',response.data.data.jwt)
      tools.setLocal('dealerToken',response.data.data.jwt)
      tools.setLocal('refreshToken',response.data.data.jwt)



      var exp = new Date();
      exp.setTime(exp.getTime() + 6 * 60 * 60 * 1000);
      window.document.cookie = "Authorization=" + response.data.data.jwt+ ";expires=" + exp.toGMTString()+";path= /";
      window.refreshToken = 2;
      axios.defaults.headers.common['Authorization'] = response.data.data.jwt
    }


    let info = response.data.message || ''

    let langArr = ['en-US','en_US','en']
    if(langArr.includes(local) && errorCode[response.data.code]){
      info = errorCode[response.data.code]
    }
  
    if(type === 1){
      // console.log('登录失败',info)
      if(response.data.code !=1){
        Message.error({
          content:info,
          duration:1.5,
          onClose: ()=>{
              fn()
          }
        });
 
      }else if(response.data.code == 1){
        Message.success({
          content:response.data.message || '登录成功 Log in successfully',
          duration:1.5,
          onClose: ()=>{
            fns(response.data.data)
            router.push({name:'home'})
          }
        });
      }
      
    }   
  }).catch(function (error) {
    console.log(error)
    // let info = error.message || '登录失败 Log in failure'
  
    // if(local =='en-US' && error.code){
    //     // console.log('en-US',response.code)
    //    info = errorCode[error.code]
    // }
    // //消息弹出框
    // Message.error({
    //   content:info,
    //   duration:1.5,
    //   onClose: ()=>{
    //       fn()
    //   }
    // });
    setTimeout(()=>{
      fn()
    },1500)
  });
}



export default {
  isExp,getNewToken
}